import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInteceptor } from './auth-interceptor';

export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInteceptor, multi: true },
]
